module.exports = __webpack_public_path__ + "img/2.e08bdf61.jpg";